import { render, staticRenderFns } from "./OrderForms.vue?vue&type=template&id=a24e29e0&scoped=true&"
import script from "./OrderForms.vue?vue&type=script&lang=js&"
export * from "./OrderForms.vue?vue&type=script&lang=js&"
import style0 from "./OrderForms.vue?vue&type=style&index=0&id=a24e29e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e29e0",
  null
  
)

export default component.exports